import * as THREE from "three";
import {GeneratorValues} from "../../../product-types";
import {curveSegments, wallThickness} from "../../../../consts";

export const createBase = (radius: number, values: GeneratorValues) => {
    const circleShape = new THREE.Shape();
    circleShape.absarc(0, 0, radius, 0, Math.PI * 2, false);

    const hole = new THREE.Shape()
        .absarc(0, 0, radius - wallThickness, 0, Math.PI * 2, false);
    circleShape.holes.push(hole);

    const extrudeSettings = {
        depth: values.height,
        curveSegments: curveSegments,
        steps: 32,
    };

    return new THREE.ExtrudeGeometry(circleShape, extrudeSettings);
}